export const filterItemsBySearch = (
  options: { id: string | number; name: string }[],
  search: string
): typeof options => {
  if (!search.trim()) return options;
  const searchLower = search.toLowerCase();
  return options.filter(option =>
    option.name.toLowerCase().includes(searchLower)
  );
};

export const getVisibleItems = <T>(
  items: T[],
  showAll: boolean,
  threshold: number
): T[] => {
  return showAll ? items : items.slice(0, threshold);
};

export const DEFAULT_SEARCH_THRESHOLD = 20;
export const DEFAULT_SHOW_MORE_THRESHOLD = 5;
